import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import personalizedProgramsImg from '../assets/images/personalized_programs.png';
import remoteMonitoringImg from '../assets/images/remote_monitoring.png';
import aiCoachImg from '../assets/images/ai_coach.png';
import realTimeFeedbackImg from '../assets/images/real_time_feedback.png';
import augmentedRealityImg from '../assets/images/augmented_reality.png';

const Features = ({ texts }) => {
    const featureImages = [
        personalizedProgramsImg,
        remoteMonitoringImg,
        aiCoachImg,
        realTimeFeedbackImg,
        augmentedRealityImg,
    ];

    return (
        <section id="features" className="features-section d-flex align-items-center">
            <Container>
                <h2 className="text-center mb-4">{texts.features.title}</h2>
                <Row className="justify-content-center mb-4">
                    {texts.features.items.map((item, index) => (
                        <Col xs={12} sm={6} md={4} className="mb-4" key={index}>
                            <Card className="feature-card text-center">
                                <Card.Img variant="top" src={featureImages[index]} alt={item.title} className="feature-img" />
                                <Card.Body>
                                    <Card.Title>{item.title}</Card.Title>
                                    <Card.Text>{item.description}</Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default Features;